import CollapseHeader from './CollapseHeader';

export default CollapseHeader;
